<template>
    <div class="image-pinch" :class="{loading}">
        <div class="loading"><div class="cr-spinner"></div></div>
        <img ref="image" @load="resizeImage" :src="image"/>
    </div>
</template>

<script>
    export default {
        name: "ImagePinch",

        props: {
            image: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                loading: true,
                hammerInitialized: false,

                initialScale: null,

                posX: 0,
                posY: 0,
                scale: this.initialScale,
                last_scale: this.initialScale,
                last_posX: 0,
                last_posY: 0,
                max_pos_x: 0,
                max_pos_y: 0,
                transform: ""
            }
        },

        mounted() {
            window.addEventListener('orientationchange', this.resizeImage);
            window.addEventListener('resize', this.resizeImage);
        },

        beforeDestroy() {
            window.removeEventListener('orientationchange', this.resizeImage);
            window.removeEventListener('resize', this.resizeImage);
        },

        methods: {
            resizeImage() {
                this.initialScale = null;

                const intervalId = setInterval(() => {
                    const imageHeight = this.$refs.image.offsetHeight;

                    if (imageHeight) {
                        clearInterval(intervalId);

                        this.initialScale = this.$refs.image.parentElement.offsetHeight / imageHeight;
                        this.scale = this.initialScale;
                        this.last_scale = this.initialScale;

                        this.$refs.image.style.webkitTransform = "translate3d(-50%, -50%, 0) " + "scale3d(" + (this.initialScale) + ", " + (this.initialScale) + ", 1)";

                        this.$nextTick(() => {
                            this.loading = false;
                            if (!this.hammerInitialized) {
                                this.initHammer();
                            }
                        });
                    }
                }, 100);
            },

            initHammer() {
                const hammerInstance = new Hammer(this.$refs.image, {});

                hammerInstance.get('pinch').set({enable: true});
                hammerInstance.on('doubletap pan pinch panend pinchend', ev => this.handleGestureEvent(ev));

                this.hammerInitialized = true;
            },

            handleGestureEvent(ev) {
                this.$emit('pinch');

                if (ev.type === "doubletap") {
                    if (this.scale < 3 * this.initialScale) {
                        this.scale = Math.min(this.scale + this.initialScale, 4 * this.initialScale);
                    } else {
                        this.scale = this.initialScale;
                    }
                }

                //pan
                this.posX = this.last_posX + ev.deltaX;
                this.posY = this.last_posY + ev.deltaY;

                if (this.$refs.image.parentElement.offsetWidth < (this.scale * this.$refs.image.offsetWidth)) {
                    let parent_max_pos_x = Math.max(0, ((this.scale * this.$refs.image.offsetWidth) - this.$refs.image.parentElement.offsetWidth) / 2);
                    let image_max_pos_x = Math.ceil(Math.abs(this.scale - this.initialScale) * this.$refs.image.offsetWidth / 2);
                    this.max_pos_x = Math.min(parent_max_pos_x, image_max_pos_x);
                } else {
                    this.max_pos_x = 0;
                }

                if (this.$refs.image.parentElement.offsetHeight < (this.scale * this.$refs.image.offsetHeight)) {
                    let parent_max_pos_y = Math.max(0, ((this.scale * this.$refs.image.offsetHeight) - this.$refs.image.parentElement.offsetHeight) / 2);
                    let image_max_pos_y = Math.ceil(Math.abs(this.scale - this.initialScale) * this.$refs.image.offsetHeight / 2);
                    this.max_pos_y = Math.min(parent_max_pos_y, image_max_pos_y);
                } else {
                    this.max_pos_y = 0;
                }

                if (this.posX > this.max_pos_x) {
                    this.posX = this.max_pos_x;
                }
                if (this.posX < -this.max_pos_x) {
                    this.posX = -this.max_pos_x;
                }
                if (this.posY > this.max_pos_y) {
                    this.posY = this.max_pos_y;
                }
                if (this.posY < -this.max_pos_y) {
                    this.posY = -this.max_pos_y;
                }

                //pinch
                if (ev.type === "pinch") {
                    this.scale = Math.max(this.initialScale, Math.min(this.last_scale * (ev.scale), 4 * this.initialScale));
                }
                if (ev.type === "pinchend") {
                    this.last_scale = this.scale;
                }

                //panend
                if (ev.type === "panend") {
                    this.last_posX = this.posX < this.max_pos_x ? this.posX : this.max_pos_x;
                    this.last_posY = this.posY < this.max_pos_y ? this.posY : this.max_pos_y;
                }

                this.transform =
                    `translate3d(calc(-${50}% + ${this.posX}px), calc(-${50}%  + ${this.posY}px), 0) ` +
                    `scale3d(${this.scale}, ${this.scale}, 1)`;

                if (this.transform) {
                    this.$refs.image.style.webkitTransform = this.transform;
                }
            }
        },
    }
</script>